import axios from 'axios';
import moment from 'moment';
import { constructServiceURL } from '../../../../../utils/URLTools';

const apiFetchRecalculateTasksCreate = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: 'createRecalculateTasks',
    stub: process.env.useStubbedEndpoints,
    pathParameters: {
      appContext: payload.appContext.appContext,
    },
  });
  return axios.post(serviceUrl, {
    impcCode: payload.params.impcCode,
    calculateFromDate: moment(payload.params.calculateFromDate).format('YYYY-MM-DD'),
  });
};

export default apiFetchRecalculateTasksCreate;
